import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class EscenariosService {

  constructor(private http: HttpClient) { }

  public obtenerListaEscenarios(paginator){
      return this.http.get(GlobalVariable.API_SERVER_URL+"escenarios/empresa/"+paginator.filter.id_empresa+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public guardarEscenario(escenario){
    return this.http.post(GlobalVariable.API_SERVER_URL+"escenarios",escenario, GlobalVariable.httpOptions);
  }

  public actualizarEscenario(escenario){
    return this.http.put(GlobalVariable.API_SERVER_URL+"escenarios/"+escenario.id,escenario, GlobalVariable.httpOptions);
  }
}
